import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable} from 'rxjs';
import { catchError  } from 'rxjs/operators';
import { throwError  } from "rxjs";
import { AuthService } from './services/auth.service';
import { ILogger, LOGGER_TOKEN } from './services/logger/ilogger';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private logger = inject<ILogger>(LOGGER_TOKEN);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(request)
    .pipe(
      // Delay and/or retry (not completed)
      /* retryWhen(errors =>
        errors.pipe(
          delay(1000),
          tap(errorStatus => {
            if (!errorStatus.startsWith('5')) {
              throw errorStatus;
            }   
          })
        )
      ), */ 
      //retry(2), // retry twice
      catchError(response => {

        if (response instanceof HttpErrorResponse) {
          this.logger.error('HTTP request failed', {
            source: 'http-interceptor',
            url: response.url ?? request.url,
            method: request.method,
            status: response.status,
            statusText: response.statusText,
            requestUrl: request.url
          });

          if (response.status === 0) {
            if (response.url?.includes('user/me')) {
              this.authService.userAuthFailed.next(true);
            }
          }
          else if (response.status == 401) {

            if (response.url?.includes('user/me')) { // Do not redirect unless user profile lookup failure
              this.authService.userAuthFailed.next(true);
              this.authService.redirectToErrorByID(response.status);
            }
            else {
              this.authService.userSessionTimedOut.next(true)
            }

          }

        }
        return throwError(response);
      })
    )
   }
}

